import React from 'react';
import { Container, Row, Col } from "react-bootstrap";

import './pageTitle.module.css';

const PageTitle = ({ title, subTitle, fluid, variant }) => {

    return (
        (!!title || !!subTitle) ?
        <Container fluid={!!fluid ?? false}>
            {/* <Row className={(!!subTitle ? "text-center mb-5" : "text-center mb-3")}>
                <Col xs={12}>
                    <span styleName={(variant === "light") ? "page-title light" : "page-title"}>
                        {title}
                    </span>
                </Col>

            </Row> */}
            <Row className="">
                <Col xs={12}>
                    <h3 className={`section-title text-center ${!!subTitle && 'mb-3'}`}>{title}</h3>
                </Col>
                {!!subTitle &&
                    <Col xs={12} className="text-center mb-5">
                        <span styleName={(variant === "light") ? "page-sub-title light" : "page-sub-title"}>
                            {subTitle}
                        </span>
                    </Col>
                }
            </Row>
        </Container> : null
    )
}

export default PageTitle;